import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=22cf8ec6&"
import script from "./Order.vue?vue&type=script&lang=ts&"
export * from "./Order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports